import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as Actions from '../../store/actions';
import {quickActionsNew} from '../../assets/images/images';
import DashboardLayout from '../../components/DashboardLayout';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import {api} from 'helpers';
import {useQuery} from 'react-query';

function QuickActionsWrapper({children, topup, auth: {userDetails}}) {
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 96);
  const lighterShadeDeep = getLighterShade(baseColor, 80);

  const fetcher = url => api.get(url).then(res => res.data);
  const url = `/support/information-banner`;

  const {data: bannerData, isLoading: isLoadingBannerData} = useQuery(
    ['banner-info'],
    () => fetcher(`${url}?user_app=true`),
    {
      retry: false,
    },
  );

  return (
    <DashboardLayout
      xlRightPadding="xl:px-[80px]"
      topPadding="!ml-0"
      breadCrumbs={
        <p className="text-[18px] font-semibold text-deepBlue">Quick Actions</p>
      }
    >
      <div
        style={{
          backgroundColor: lighterShade,
          borderColor: 'rgba(230, 240, 255, 0.5)',
        }}
        className="py-[10px] mt-14 lg:mt-0 px-6 lg:px-0 -mx-20"
      >
        <div className="mx-20">
          {isLoadingBannerData ? (
            <div className="flex items-center gap-2 animate-pulse">
              <div
                style={{
                  backgroundColor: lighterShadeDeep,
                  borderColor: 'rgba(230, 240, 255, 0.5)',
                }}
                className="w-[38px] h-[38px] rounded-full bg-grey60 opacity-70 transition-opacity duration-1000 ease-in-out"
              />
              <div className="flex flex-col gap-2">
                <div className="h-4 w-[240px] bg-grey60 rounded-md opacity-70 transition-opacity duration-1000 ease-in-out" />
                <div className="h-3 w-40 bg-grey60 rounded-md opacity-70 transition-opacity duration-1000 ease-in-out" />
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <div
                style={{
                  backgroundColor: lighterShadeDeep,
                  borderColor: 'rgba(230, 240, 255, 0.5)',
                }}
                className="w-[38px] h-[38px] flex items-center justify-center rounded-full"
              >
                <img src={quickActionsNew} alt="icon" />
              </div>
              <div className="flex flex-col gap-0.5">
                <h1 className="font-semibold text-tiny text-deepBlue">
                  {bannerData?.data?.[0]?.Title || 'AML Screening Update'}
                </h1>
                <Link
                  to={
                    bannerData?.data?.[0]?.['CTA-Link'] || '/aml-screening/v2'
                  }
                  className="text-[#5B687B] text-small font-normal tracking-[-0.01em] underline underline-offset-2"
                >
                  {bannerData?.data?.[0]?.CTA || 'View AML Screening Update'}
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-start pt-8 px-6 lg:px-0 pb-6 justify-between">
        <h2 className="lg:text-[18px] text-base font-medium text-grey">
          Actions
        </h2>
        {topup}
      </div>
      {children}
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(QuickActionsWrapper);
